import React from 'react';

const Typograpphy = (props) => {
  return (
    <div className="mx-auto flex justify-center object-center">
      <div className={props.size}>
        <h1 className="font-bold leading-normal mt-0 mb-2 text-pink-800">
          {props.sampletext}
        </h1>
      </div>
    </div>
  );
};

export default Typograpphy;
